

import React, { memo } from 'react';
import { Icon } from '../../../../../ui-kit';
import '../styles/_file-type-icon.scss';

function FileTypeIcon({ name, ...iconProps }) {
  return (
    <div className="file-type-icon">
      <Icon size={17.5} color="white" name={name} {...iconProps} />
    </div>);

}

export default memo(FileTypeIcon);